<div [class.map-full-screen]="isFullScreen" class="wrapper">
  <div class="left">
    <app-search-map-wrapper class="map">
      <router-outlet name="map"></router-outlet>
    </app-search-map-wrapper>
    @if (!isFullScreen) {
      <div
        [class.sidenav-open]="showSidenav"
        class="content"
        >
        <router-outlet name="searchContent" />
      </div>
    }
  </div>
  @if (showSidenav) {
    <div
      [@rightAnimation]="showSidenav ? 'sidenavOpen' : 'sidenavClosed'"
      class="right"
      >
      <div class="close-block">
        <mat-icon
          (click)="close()"
          class="close-icon"
          svgIcon="close"
          />
      </div>
      <ng-container #container></ng-container>
    </div>
  }
</div>
